<template>
<div>
    <v-dialog v-model="open_page_advertise" persistent max-width="600px">
        <div v-if="loading_page_advertise === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <v-card v-if="loading_page_advertise === false">
            <v-card-title class="justify-end">
                <div class="cursor_advertise" @click="closeAdvertise()">
                    <v-icon>mdi-close</v-icon>
                </div>
            </v-card-title>

            <v-card-text>
                <div class="img_advertise">
                    <img :src="pictureAdvertise">
                </div>
            </v-card-text>
            <v-card-actions>

            </v-card-actions>

        </v-card>
    </v-dialog>
</div>
</template>

<script>
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page_advertise: false,
            open_page_advertise:true,
        }
    },
    props:['pictureAdvertise'],
    methods:{
        closeAdvertise(){
            this.open_page_advertise = false
            this.$store.commit('closeAdvertise')
        }
    }
}
</script>

<style scoped>
.cursor_advertise {
    cursor: pointer;
}

.img_advertise {
    width: 100%;
}

.img_advertise>img {
    max-width: 100%;
}
</style>
